var L;!function(L){L.WITHLINK="OUTLINED",L.DEFAULT="DEFAULT"}(L||(L={}));export{L as ImageholderVariants};
//# sourceMappingURL=enums.js.map
